import { render } from "./ProjectNewModal.vue?vue&type=template&id=1652ade0&scoped=true&ts=true"
import script from "./ProjectNewModal.vue?vue&type=script&lang=ts"
export * from "./ProjectNewModal.vue?vue&type=script&lang=ts"

import "./ProjectNewModal.vue?vue&type=style&index=0&id=1652ade0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1652ade0"]])

export default __exports__